import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import { UploadIcon } from '../../shared/icon-svg/icon';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useAppSelector } from '../../../../../app/config/store';

const DropzoneField = ({ sectionIndex, editId, fieldKey, value, id, setFiles, onFilesChange, isDeleted }) => {
  const [isDrag, setIsDrag] = useState<boolean>(false);
  const aiChatId = useAppSelector(state => state.caseReview.entity.data);
  const [uploadFiles, setUploadFiles] = useState<any>([]);
  const MAX_FILE_SIZE = 25 * 1024 * 1024;
  const ALLOWED_TYPES = [
    'image/*',
    'audio/mpeg',
    'audio/wav',
    'video/mp4',
    'application/pdf',
    'text/plain',
    'text/markdown',
    'text/csv',
    'application/rtf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.oasis.opendocument.presentation',
    'application/json',
    'application/zip',
    'text/html',
    'audio/ogg',
  ];

  useEffect(() => {
    if (isDeleted) {
      setUploadFiles([]);
    }
  }, [isDeleted]);

  useEffect(() => {
    if (value !== null && value?.length !== 0 && editId) {
      value && setUploadFiles([{ name: value }]);
    }
  }, [value, editId]);

  const onDrop = useCallback(
    acceptedFiles => {
      if (value !== undefined && value?.length !== 0) {
        toast.warn('Please delete the uploaded file(s) before uploading new ones.', {
          position: 'top-right',
        });
        return;
      }
      const oversizedFiles = acceptedFiles.filter(file => file.size > MAX_FILE_SIZE);
      const invalidFiles = acceptedFiles.filter(file => !ALLOWED_TYPES.includes(file.type) && !file.type.startsWith('image/'));
      let validFiles = acceptedFiles.filter(file => ALLOWED_TYPES.includes(file.type) || file.type.startsWith('image/'));
      if (invalidFiles.length > 0) {
        toast.error(` ${invalidFiles.map(file => file.name).join(', ')}  file are not supporting.`, {
          position: 'top-right',
        });
      }

      if (oversizedFiles.length > 0) {
        toast.error('Maximum size to upload files should be 25 MB', {
          position: 'top-right',
        });
      } else {
        const blobFiles: any = validFiles.map(file => ({
          name: file.name,
          file,
        }));
        setIsDrag(false);
        if (onFilesChange) {
          setUploadFiles(prevFiles => {
            const updatedFiles = [...blobFiles];

            if (onFilesChange) {
              onFilesChange(updatedFiles);
            }

            return updatedFiles;
          });
        }
        setFiles(pre => [...pre, acceptedFiles]);
      }
    },
    [onFilesChange, sectionIndex, fieldKey],
  );

  const handleRemoveFile = (indexToRemove: number) => {
    setUploadFiles([]);
    onFilesChange?.([]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    // accept: {
    //   'image/*': [],
    //   'video/*': [],
    //   'audio/wav': [],
    //   'audio/mpeg': [],
    //   'application/pdf': [],
    //   'text/plain': [],
    //   'text/markdown': [],
    //   'text/csv': [],
    //   'application/rtf': [],
    //   'application/msword': [],
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
    //   'application/vnd.ms-excel': [],
    //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    //   'application/vnd.ms-powerpoint': [],
    //   'application/vnd.openxmlformats-officedocument.presentationml.presentation': [],
    //   'application/vnd.oasis.opendocument.presentation': [],
    //   'application/json': [],
    //   'application/zip': [],
    //   'text/html': [],
    // },
    onDrop,
    onDragEnter: () => setIsDrag(true),
    onDragLeave: () => setIsDrag(false),
  });

  return (
    <>
      <div
        {...getRootProps()}
        className="dropzone text-center"
        style={{ border: `${isDrag ? '2px dashed #007bff' : '1px dashed #cacaca'}` }}
      >
        <input {...getInputProps()} />
        <div className="icon">
          <UploadIcon />
        </div>
        <p className="click-upload">
          <span>Click to Upload</span> or Drag and Drop
        </p>
        <p>(Max File size 25MB)</p>
      </div>
      {uploadFiles?.length > 0 && (
        <div className="upload-file-name d-flex flex-wrap justify-content-start align-items-center gap-2 p-1">
          {uploadFiles.map((item, index) => (
            <div key={index} className="d-flex align-items-center bg-light px-2 py-1 rounded">
              <span className="me-2">{item?.name}</span>
              <button
                type="button"
                className="btn-close"
                aria-label="Remove"
                onClick={() => handleRemoveFile(index)}
                style={{ fontSize: '0.6rem' }}
              ></button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default DropzoneField;
